export default {
  allAttributes: [],
  relatedAttributeData: [],
  attributesActive: false,
  listingAttributeGroupCombos: [],
  attributeFilterQueryStringVar: '',
  activeAttributeFilters: [],
  attributeRecordsUsed: [],
  productAttributeInfoData: [],
  attributeMergeDuplicateValuesByName: false
}
